import { graphql } from "gatsby"
import React from "react"
import Banner from "../components/Microsites/Banner"
import BrandListing from "../components/Microsites/BrandListing"
import ContactInfo from "../components/Microsites/ContactInfo"
import ExporeDetails from "../components/Microsites/ExporeDetails"
import Faqs from "../components/Microsites/Faqs"
import Gallery from "../components/Microsites/Gallery"
import ImageCardSlider from "../components/Microsites/ImageCardSlider"
import ImageWithContent from "../components/Microsites/ImageWithContent"
import Instagram from "../components/Microsites/Instagram"
import MenusDetails from "../components/Microsites/MenusDetails"
import RelatedCards from "../components/Microsites/RelatedCards"
import Testimonial from "../components/Microsites/Testimonial"
import LabellePackage from "../components/Microsites/LabellePackage"

const Microsites = props => {
  const modules = props.modules.restaurantContent
  const { location } = props

  const components = {
    Banner: Banner,
    ExporeDetails: ExporeDetails,
    ImageWithContent: ImageWithContent,
    ImageCardSlider: ImageCardSlider,
    Instagram: Instagram,
    Testimonial: Testimonial,
    RelatedCards: RelatedCards,
    MenusDetails: MenusDetails,
    Gallery: Gallery,
    Faqs: Faqs,
    ContactInfo: ContactInfo,
    BrandListing: BrandListing,
    LabellePackage: LabellePackage,
  }

  return (
    <>
      {modules
        ? modules.map((module, i) => {
            const moduleName = module.__typename.replace(
              "WpEatDrink_Restaurantcontent_RestaurantContent_",
              ""
            )
            return (
              components[moduleName] &&
              React.createElement(components[moduleName], {
                key: i,
                module,
                location,
                i,
                siteName: props.siteName,
              })
            )
          })
        : null}
    </>
  )
}

export default Microsites

export const EatDrinkFragment = graphql`
  fragment EatDrinkFragment on WpEatDrink {
    restaurantContent {
      restaurantContent {
        __typename
        ...EatDrinkBannerFragment
        ...EatDrinkExporeDetailsFragment
        ...EatDrinkImageWithContentFragment
        ...EatDrinkImageCardSliderFragment
        ...EatDrinkInstagramFragment
        ...EatDrinkTestimonialFragment
        ...EatDrinkRelatedCardsFragment
        ...EatDrinkMenusDetailsFragment
        ...EatDrinkGalleryFragment
        ...EatDrinkFaqsFragment
        ...EatDrinkContactInfoFragment
        ...EatDrinkBrandListingFragment
        ...EatDrinkLabellePackageFragment
      }
    }
  }
`
